import { Select } from "antd";

export function filtrarOpcaoPorLabel(input, option) {
  const termo = String(input).toLowerCase();
  const texto =
    option?.label ?? option?.props?.label ?? option?.children ?? "";
  if (typeof texto !== "string") {
    return false;
  }
  return texto.toLowerCase().includes(termo);
}

export function SelectBuscavel({ showSearch = true, ...rest }) {
  return (
    <Select
      showSearch={showSearch}
      optionFilterProp="label"
      filterOption={filtrarOpcaoPorLabel}
      {...rest}
    />
  );
}
